import { Type } from '@angular/core';
import { ComponentLoader } from '../tokens/component-loader.type';

/**
 * Returns a memoized ComponentLoader that resolves the same component class on every call.
 * Use in kiraah-app shell providers for cross-lib dynamic component wiring.
 */
export function createMemoizedComponentLoader(
  importer: () => Promise<Type<unknown>>
): ComponentLoader {
  let cachedComponent: ReturnType<ComponentLoader> | null = null;
  return () => (cachedComponent ??= importer());
}
